import React from 'react';
import { Discount } from '../../../../types/discounts';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

interface StoreProps extends WithTranslation {
    discount: Discount;
}

const Store = (
    {
        discount,
        t,
    }: StoreProps
) => {
    // @ts-ignore
    const { store } = discount;
    if (!store) return null;

    return (
        <StoreContainer>
            <Header>{t('customers.customer.discounts.store')}</Header>
            <Value>{store.name}</Value>
        </StoreContainer>
    );
};

export default withTranslation()(Store);

const StoreContainer = styled.div`
    margin-top: 16px;
    font-size: 14px;
`;

const Header = styled.span`
    font-weight: 700;
    color: #46535E;
`;

const Value = styled.span`
    margin-left: 8px;
`;
